import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography, List, ListItem, ListItemButton, ListItemIcon, Checkbox, ListItemText, Button } from '@mui/material';
import emptyContactsImg from 'src/img/empty-contacts.svg';
import { useStore } from 'src/stores';
import useStyles from './styles';
import { observer } from 'mobx-react-lite';
export const ExistingMember = observer(_ref => {
  let memberType = _ref.memberType,
    handleModalClose = _ref.handleModalClose;
  const store = useStore();
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const isBuildingStoreEntity = memberType === 'building';
  const storeEntity = isBuildingStoreEntity ? store.addNewProperty.contactInformation.selectBuildingContacts : store.addNewProperty.contactInformation.selectUtilitiesContacts;
  const isListItemChecked = id => {
    return !!storeEntity.filter(item => item.id === id).length;
  };
  const handleToggle = member => () => {
    if (isBuildingStoreEntity) {
      if (isListItemChecked(member)) {
        store.addNewProperty.removeBuildingContacts(member);
      } else {
        store.addNewProperty.addBuildingContacts(member);
      }
    } else {
      if (isListItemChecked(member)) {
        store.addNewProperty.removeUtilitiesContacts(member);
      } else {
        store.addNewProperty.addUtilitiesContacts(member);
      }
    }
  };
  return /*#__PURE__*/React.createElement("form", {
    className: classes.form
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.formContent
  }, store.addNewProperty.contactInformation.teammembers.length > 0 && /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, t('add_new_property_flow.pick_contact')), /*#__PURE__*/React.createElement("div", {
    className: classes.xsSection
  }, store.addNewProperty.contactInformation.teammembers.length > 0 ? /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, t('add_new_property_flow.change_contacts')) : /*#__PURE__*/React.createElement("div", {
    className: classes.emptyState
  }, /*#__PURE__*/React.createElement("img", {
    src: emptyContactsImg,
    width: "160",
    height: "160",
    alt: "empty contacts image"
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    color: "light"
  }, t('add_new_property_flow.not_invited_team')))), store.addNewProperty.contactInformation.teammembers.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, /*#__PURE__*/React.createElement(List, {
    variant: "classic"
  }, store.addNewProperty.contactInformation.teammembers.map(member => {
    if (member.accountId === store.account.userProfile.id || !member.isEnabled) return;
    return /*#__PURE__*/React.createElement(ListItem, {
      disablePadding: true,
      key: member.id
    }, /*#__PURE__*/React.createElement(ListItemButton, {
      role: undefined,
      onClick: handleToggle(member.id),
      dense: true,
      'custom-attribute': '88-existing-member'
    }, /*#__PURE__*/React.createElement(ListItemIcon, null, /*#__PURE__*/React.createElement(Checkbox, {
      checked: isListItemChecked(member.id),
      edge: "start",
      disableRipple: true
    }), /*#__PURE__*/React.createElement(ListItemText, {
      primary: "".concat(member.firstName, " ").concat(member.lastName)
    }))));
  })))), /*#__PURE__*/React.createElement("div", {
    className: classes.formFooter
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.footerEven
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.footerWrapper
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "text",
    type: "button",
    onClick: handleModalClose,
    'custom-attribute': '89-existing-member'
  }, t('buttons.cancel'))), /*#__PURE__*/React.createElement("div", {
    className: classes.footerWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.footerButton
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "text",
    type: "button",
    onClick: handleModalClose,
    'custom-attribute': '90-existing-member'
  }, t('buttons.save_selection')))))));
});